exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.highlight-badge[data-v-2f30ac91]  {\n    padding: 5px 10px;\n    border-radius: 5px !important;\n    font-weight: bold;\n}\n", ""]);

// exports
